;(function (window, app) {

    /**
     * Default YouTube Iframe Player config
     */
    var config = {
        height: '100%',
        width: '100%',
        playerVars: {
            rel: 0,
            modestbranding: 1,
            autohide: 1,
            color: 'white',
        },
    };

    /**
     * Gets a YouTube Iframe Player
     * {@link https://developers.google.com/youtube/iframe_api_reference}
     *
     * @param {DOM element} placeholderElem - Placeholder element to be
     *  replaced with YouTube Iframe
     * @param {string} videoId - YouTube video ID to be played
     * @return {Promise} Resolves with YouTube player
     */
    var getPlayer = function getPlayer(placeholderElem, videoId, cb) {
        return new Promise(function (res) {
            if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
                queueYouTubeIframeAPIReadyCallback(function () {
                    res(createPlayer(placeholderElem, videoId));
                });
            } else {
                res(createPlayer(placeholderElem, videoId));
            }
        });
    };

    /**
     * Creates a YouTube Iframe Player object
     * {@link https://developers.google.com/youtube/iframe_api_reference}
     *
     * @param {DOM element} placeholderElem - Placeholder element to be
     *  replaced with YouTube Iframe
     * @param {string} videoId - YouTube video ID to be played
     *  player
     */
    var createPlayer = function createPlayer(placeholderElem, videoId) {
        return new YT.Player(placeholderElem, {
            videoId: videoId,
            height: config.height,
            width: config.width,
            playerVars: config.playerVars,
        });
    };

    /**
     * Queues a callback to be called when YouTube Iframe API is ready,
     * while retaining previously-defined callbacks.
     *
     * @param {function} cb - Callback function to be queued
     */
    var queueYouTubeIframeAPIReadyCallback = function queueYouTubeIframeAPIReadyCallback(cb) {
        if (typeof window.onYouTubeIframeAPIReady === 'function') {
            // make sure we don't clobber previously registered callbacks
            var previousCb = window.onYouTubeIframeAPIReady;
            window.onYouTubeIframeAPIReady = function () {
                previousCb();
                cb();
            }
        } else {
            // queue creation of player after YT Iframe API ready
            window.onYouTubeIframeAPIReady = cb;
        }
    };

    app.extend({
        youtubeIframePlayerEmbedder: {
            getPlayer: getPlayer,
        },
    });

    return app.youtubeIframePlayerEmbedder;

})(window, window.app);
